import { FormikProps } from 'formik';
import React from 'react';
import { AddressField } from '../../../../global/components/form-element/address';
import { FormField } from '../../../../global/components/form-element/form-field';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { Person } from '../../../../global/models/person-model';
import { RelationshipsProps } from '../../models/account-info-epi-props';
import { MailingAddressFieldNames } from '../../models/form-models';
import { getAddressLabels } from '../../selectors/form-selectors';
import { BasicInfo } from '../personal-info/basic-info';
import { EmailInfo } from '../personal-info/email-info';
import { PhoneInfo } from '../personal-info/phone-info';
import { DependentFields } from './dependent-fields';
import { DependentFormValues, DependentMailingAddressRequiredSchema } from './dependent-form-models';
import { ChildTypes } from './dependents-model';


interface Props {
	formProps: FormikProps<DependentFormValues>;
	relationshipsProps: RelationshipsProps;
	labelSetting: LabelSettingProps;
	isAdd: boolean;
	addressExpired: boolean;
	addressExpiredError: boolean;
	setAddressExpiredError: (value: boolean) => any;
	currentPerson: Person;
	dependentIsClergy: boolean;
    dobWarningMessage: JSX.Element;
    skipDocUpload: boolean;
}
export function DependentFormFields(props: Props) {
	const { formProps, relationshipsProps, isAdd, labelSetting, addressExpired, addressExpiredError, setAddressExpiredError, currentPerson, dependentIsClergy, skipDocUpload } = props;

	function GetSectionText() {
		switch (formProps?.values?.child_type) {
			case ChildTypes.legal:
				return <ContentSpacer><h2>{relationshipsProps.addChildSectionTitle}</h2></ContentSpacer>;
			case ChildTypes.adopted:				
				return (
					<>
						<ContentSpacer>
							<h2>{relationshipsProps.addAdoptedChildSectionTitle}</h2>
						</ContentSpacer>
						<ContentSpacer>
							<FormField
								name='start_date'
								label={relationshipsProps?.adoptionStartDateLabel}
								component='datePicker'
								touched={formProps.touched}
								errors={formProps.errors}
								required
								autoWidth
							/>
						</ContentSpacer>
					</>
				);
			case ChildTypes.step:
				return (
					<>
						<ContentSpacer>
							<h2>{relationshipsProps.addStepchildSectionTitle}</h2>
						</ContentSpacer>
						<ContentSpacer>
							<FormField
								name='start_date'
								label={relationshipsProps?.relationshipStartDateLabel}
								component='datePicker'
								touched={formProps.touched}
								errors={formProps.errors}
								required
								autoWidth
							/>
						</ContentSpacer>
					</>
				);
			default:
				return <ContentSpacer><h2>{relationshipsProps.addChildSectionTitle}</h2></ContentSpacer>;

		}
	}

	return (
		<>
			<DividerSection>
				<DependentFields
					formProps={formProps}
					relationshipProps={relationshipsProps}
					disabled={!isAdd}
				/>
			</DividerSection>
			{
				formProps?.values?.child_type &&
				<>
					{GetSectionText()}
					<DividerSection sectionText={relationshipsProps.dependentInformationSectionLabel}>
						<BasicInfo
							labelSetting={labelSetting}
							formikProps={formProps}
							salutationRequired={dependentIsClergy}
							currentPerson={currentPerson}
							docUpload={!isAdd && !skipDocUpload}
							taxIdOptional
							dobWarningMessage={props.dobWarningMessage}
						/>
					</DividerSection >

					<DividerSection sectionText={labelSetting.mailingAddressTitle}>

						<AddressField
							currentCountry={formProps.values.mailing_country === '' ? 'US' : formProps.values.mailing_country}
							labels={getAddressLabels(labelSetting)}
							addressFieldNames={MailingAddressFieldNames}
							requiredSchema={DependentMailingAddressRequiredSchema}
							formProps={formProps}
							addressExpired={addressExpired}
							addressExpiredError={addressExpiredError}
							expiredAddressChangeToggle={(hasChanged: boolean) => setAddressExpiredError(!hasChanged)}
							person
						/>
					</ DividerSection>

					<PhoneInfo
						labelSetting={labelSetting}
						formProps={formProps}
						hideBusiness
					/>

					<EmailInfo
						labelSetting={labelSetting}
						formProps={formProps}
						hideDescription
						hideBusiness
						removeDivider

					/>
				</>
			}
		</>
	);

}